<template>
    <div class="loan_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('融资协议') }}</div>
        </div>
        <!-- 顶部图 -->
        <div class="top">
            <img class="logo" :src="logo" alt="">
        </div>
        <div class="merchantSettled-wap">
            <div class="step-div">
                <div class="content">
                    <div>
                        <div class="title">{{ $t("contract_title") }}</div>
                        <p>{{ $t("contract_titleInfo", { name: itemname }) }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title1") }}</div>
                        <p>{{ $t("contract_title1info") }}</p>
                        <p>{{ $t("contract_title1info1") }}</p>
                        <p>{{ $t("contract_title1info2") }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title2") }}</div>
                        <p>{{ $t("contract_title2info1") }}</p>
                        <p>{{ $t("contract_title2info2") }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title3") }}</div>
                        <p>{{ $t("contract_title3info") }}</p>
                        <p>{{ $t("contract_title3info1", { name: itemname }) }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title4") }}</div>
                        <p>{{ $t("contract_title4info") }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title5") }}</div>
                        <p>{{ $t("contract_title5info") }}</p>
                        <p>{{ $t("contract_title5info1") }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title6") }}</div>
                        <p>{{ $t("contract_title6info") }}</p>
                        <p>{{ $t("contract_title6info1") }}</p>
                    </div>
                    <div>
                        <div class="title">{{ $t("contract_title7") }}</div>
                        <p>{{ $t("contract_title7info") }}</p>
                        <p>{{ $t("contract_title7info1") }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <footers></footers>
    </div>
</template>

<script>
import footers from '@/components/bsFooter.vue'
import { Toast, Icon } from 'vant'
export default {
    components: {
        footers
    },
    data() {
        return {
            itemname:'华南电影',
            logo: localStorage.getItem('logo') || '',

        }
    },
    async created() {
        this.$parent.footer('item', false);

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.red_top_bg {
    position: fixed;
    top: 0;
    z-index: 10;
}

.loan_wrap {
    width: 100%;
    height: 100%;
    font-size: 14px;
    padding-top: 44px;
}

.top {
    width: 100%;
    height: 300px;
    background: url('~@/assets/images/banner.jpg') no-repeat 60% center / 300%;
    position: relative;
    .logo {
        width: fit-content;
        height: 40px;
        position: absolute;
        top: 20px;
        left: 20px;
        img {
            display: block;
            height: 100%;
            width: auto;
        }
    }
}
.merchantSettled-wap {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;

  .step-div {
    width: 100%;
    background: #fff;

    .content {
      padding: 20px 15px;
      border: 1px solid #eeeeee;
      h2 {
        margin-top: 14px;
      }
      .title {
        font-size: 24px;
        color: #0f1111;
        font-weight: 500;
        margin-top: 14px;
      }
      .ask {
        color: dodgerblue;
      }
      p,
      ul li {
        font-family: "PingFang HK";
        font-style: normal;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        padding: 6px 0;
        list-style-type: disc;
      }
    }

    .bottom {
      height: 140px;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      margin: 20px 0;

      .button {
        width: 475px;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .merchantSettled {
    width: 100%;
    overflow: hidden;
    .merchantSettled-wap {
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100% !important;
      position: relative;
      .step-div {
        width: 100%;
        background: #fff;

        border-radius: 4px;
        margin-top: -86px;

        .content {
          padding: 20px 30px;
          border: 1px solid #eeeeee;

          .title p {
            font-family: "PingFang HK";
            font-style: normal;
            font-size: 14px;
            line-height: 20px;
            color: #333333;
            padding: 6px 0;
          }
        }

        .bottom {
          height: 100px;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          margin: 20px 0;

          .button {
            width: 80%;
          }
        }
      }
    }
  }
}
</style>